module.exports = __webpack_public_path__ + "static/media/bowen-16.27d6cd7f.jpg";